import { rematchGame } from '@/realtime/game-room-actions';

const useRematchGame = () => {
  const rematch = () => {
    rematchGame().catch(() => {});
  };

  return rematch;
};

export default useRematchGame;
